export default __webpack_public_path__ + "static/media/noumea.a55aaf78.jpg";